module.exports = __webpack_public_path__ + "img/1.02c353f4.png";